var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.userData)?_c('iframe',{staticClass:"w-full h-screen",attrs:{"src":`${_vm.url}?email=${_vm.userData.email}`,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }